import React from 'react'
import { Modal } from 'app-components/common'
import { ModalConsumer } from './ModalContext'

const ModalRoot = () => (
  <ModalConsumer>
    {({ component: Component, visible, props, hideModal }) =>
      Component ? (
        <Modal visible={visible} {...props} onClose={() => hideModal()}>
          <Component {...props} onClose={() => hideModal()} />
        </Modal>
      ) : null
    }
  </ModalConsumer>
)

export default ModalRoot
